import { Box, Circle, Stack } from '@chakra-ui/react';
import * as React from 'react';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';

type IResourceListDragHandleProps = {
  isEnabled: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
};

export const ResourceListDragHandle: React.FC<IResourceListDragHandleProps> = ({
  isEnabled,
  dragHandleProps,
}) => {
  const dotColor = isEnabled ? 'gray.500' : 'gray.300';

  return (
    <Box
      {...(isEnabled ? dragHandleProps ?? {} : {})}
      color={dotColor}
      cursor={isEnabled ? 'grab' : 'not-allowed'}
      opacity={isEnabled ? 1 : 0.7}
      userSelect="none"
      aria-label={
        isEnabled
          ? 'Drag to reorder'
          : 'Switch to Manual order to drag and rearrange'
      }
      title={
        isEnabled
          ? 'Drag to reorder'
          : 'Switch to Manual order to drag and rearrange'
      }
    >
      <Stack spacing="1">
        <Stack direction="row" spacing="1">
          <Circle size="2px" bg={dotColor} />
          <Circle size="2px" bg={dotColor} />
        </Stack>
        <Stack direction="row" spacing="1">
          <Circle size="2px" bg={dotColor} />
          <Circle size="2px" bg={dotColor} />
        </Stack>
        <Stack direction="row" spacing="1">
          <Circle size="2px" bg={dotColor} />
          <Circle size="2px" bg={dotColor} />
        </Stack>
      </Stack>
    </Box>
  );
};
